import React, { useState, useEffect } from "react";
import Artists from "../../../variables/Artists";
import Gallery from "../../components/Gallery";
import Typography from "../../../Typography";
import Button from "../../components/Button";

// Function to shuffle an array (Fisher-Yates shuffle)
const shuffleArray = (array) => {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
};

const getRandomImages = (numImages = 16) => {
  let selectedImages = [];

  // Calculate how many images we need to take from each artist
  const numArtists = Artists.length;
  const imagesPerArtist = Math.floor(numImages / numArtists); // Minimum images per artist
  let remainingImages = numImages % numArtists; // Remainder if images don't divide evenly

  // Shuffle the artists to get randomness
  shuffleArray(Artists);

  // Loop through each artist and select the required number of images
  Artists.forEach((artist) => {
    // Shuffle this artist's portfolio to randomize selection
    shuffleArray(artist.portfolioLinks);

    // Determine how many images we need from this artist
    const numImagesForThisArtist =
      imagesPerArtist + (remainingImages > 0 ? 1 : 0);

    // Select images for this artist
    const selectedForArtist = artist.portfolioLinks.slice(
      0,
      numImagesForThisArtist
    );

    // Add selected images from this artist to the final list
    selectedForArtist.forEach((image) => {
      selectedImages.push({ url: image.url, artist: artist.name });
    });

    // If we have distributed the extra image, reduce the remaining count
    if (remainingImages > 0) {
      remainingImages -= 1;
    }
  });

  // Shuffle the final selected images to mix all of them together
  shuffleArray(selectedImages);

  return selectedImages;
};

export default function HomeGallery() {
  const [images, setImages] = useState([]);
  const [isMobile, setIsMobile] = useState(false);
  const [isXsm, setIsXsm] = useState(false);

  // Check if the device is mobile
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768); // You can adjust the breakpoint as needed
      setIsXsm(window.innerWidth < 360); // You can adjust the breakpoint as needed
    };

    handleResize(); // Initial check
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    // Determine the number of images based on screen size
    let imageCount;
    if (isXsm) {
      imageCount = 8; // Small screens
    } else if (isMobile) {
      imageCount = 10; // Mobile screens
    } else {
      imageCount = 16; // Desktop screens
    }

    const randomImages = getRandomImages(imageCount); // Fetch images based on screen size
    setImages(randomImages);
  }, [isXsm, isMobile]); // Re-run effect when `isXsm` or `isMobile` changes

  return (
    <div className="relative bg-black max-xsm:py-[50px] max-md:py-[70px] py-[100px]">
      <div className="absolute left-0 right-0 bottom-0 background white-gradient h-[20px] z-10"></div>
      <div className="px-[15px]">
        <Typography.Subt className="text-[#fff] text-center">
          Our Portfolio
        </Typography.Subt>
        <Typography.P className="text-[#fff] text-center max-md:mt-[20px] mt-[30px]">
          If you are thinking about a tattoo, we will bring your idea to the
          surface! Get acquainted with our works.
        </Typography.P>
      </div>
      <Gallery images={images} className="max-md:mt-[40px] mt-[70px]" />
      <div className="flex justify-center max-md:mt-[40px] mt-[70px]">
        <Button variant="secondary">View All</Button>
      </div>
    </div>
  );
}
